import { useMemo } from "react";
import _ from "underscore";

import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import List from "@material-ui/core/List";

import { currencyTag, numberWithSpaces } from "../../../../utilities/formaters";
import { Currencies } from "../../../../shared/dictionary/enums";
import ItemTemplate from "./ItemTemplate";

import { accountingConnector } from "../../../../services/accounting/connector";

const InvestorDepositContent = ({
  ConfirmDateDeposit,
  accounting,
  investorDepositDepotIdOverride,
  idsToExcludeFromTransfer,
  setConfirmDateDeposit,
  toggleMatchedInvestorDepositSendingFlag,
  confirmMatchedInvestorDeposit,
  itemsToExclude,
}) => {
  const data = accounting.investorDepositsToTransfer.data;

  if (!Array.isArray(data)) return <div>Data is not an array...</div>;

  const [sumOfSekInvestorDeposits, sumOfEurInvestorDeposits, items] =
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useMemo(() => {
      const sumOfSekInvestorDeposits = _.reduce(
        data,
        (memo, item) => {
          return idsToExcludeFromTransfer(item) ||
            item.Currency !== currencyTag[Currencies.Sek]
            ? memo
            : item.Amount + memo;
        },
        0,
      );

      const sumOfEurInvestorDeposits = _.reduce(
        data,
        (memo, item) => {
          return idsToExcludeFromTransfer(item) ||
            item.Currency !== currencyTag[Currencies.Eur]
            ? memo
            : item.Amount + memo;
        },
        0,
      );

      let items = [];
      data.forEach((item) => {
        let itemColor = idsToExcludeFromTransfer(item) ? "yellow" : "green";
        items.push(
          <ItemTemplate
            {...{
              item,
              itemColor,
              investorDepositDepotIdOverride,
              toggleMatchedInvestorDepositSendingFlag,
            }}
          />,
        );
      });

      return [sumOfSekInvestorDeposits, sumOfEurInvestorDeposits, items];
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, itemsToExclude]);

  return (
    <div className="content-padding">
      <Card>
        <CardHeader
          title={`Investor deposits (${numberWithSpaces(sumOfSekInvestorDeposits)} ${currencyTag[Currencies.Sek]}, ${numberWithSpaces(sumOfEurInvestorDeposits)} ${currencyTag[Currencies.Eur]})`}
        />
        <CardContent>
          <DatePicker
            inputVariant="outlined"
            value={ConfirmDateDeposit}
            onChange={setConfirmDateDeposit}
            label="Confirm date"
          />
          <Button
            variant="contained"
            color="primary"
            id="confirmInvestorDeposits"
            onClick={confirmMatchedInvestorDeposits}
          >
            Confirm matched investor deposits
          </Button>
          <List>{items}</List>
        </CardContent>
      </Card>
    </div>
  );

  function confirmMatchedInvestorDeposits() {
    for (let investorDeposit of accounting.investorDepositsToTransfer.data) {
      if (!idsToExcludeFromTransfer(investorDeposit))
        confirmMatchedInvestorDeposit(
          investorDeposit.InvestorDepositId,
          investorDeposit.DepotId,
        );
    }
  }
};

export default accountingConnector(InvestorDepositContent);
